import { ReactNode } from "react";
import { useShallow } from "zustand/react/shallow";

import { useAuthStore } from "../stores/authStore";

interface CanProps {
  children: ReactNode;
  permissions: string[];
  requireAll?: boolean;
  fallback?: ReactNode;
}

export default function Can({
  children,
  permissions,
  requireAll = false,
  fallback = null,
}: CanProps) {
  const { hasAnyPermission, hasAllPermissions, user } = useAuthStore(
    useShallow((state) => ({
      hasAnyPermission: state.hasAnyPermission,
      hasAllPermissions: state.hasAllPermissions,
      user: state.user,
    })),
  );

  // Empty permissions array → visible to any authenticated user (no gate)
  if (permissions.length === 0) {
    return user ? <>{children}</> : <>{fallback}</>;
  }

  const hasAccess = requireAll
    ? hasAllPermissions(permissions)
    : hasAnyPermission(permissions);

  if (!hasAccess) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
